import React, { useState } from "react";
import { DateRangePicker } from "react-date-range";
import { defaultStaticRanges } from "./defaultRanges";
import { DateRange } from "react-date-range";

import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

import "./Datepicker.css";

import PropTypes from "prop-types";
import dayjs from "dayjs";
import ToastMessage from "../utils/muitoast";

const DateRangeSelector = ({ ranges, selectedDateRange, setSelectedDateRange, onChange, onSubmit, ...rest }) => {
  
  const [show, setShow] = useState(false);
 const [alertmessage, setAlertMessage] = useState('');
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('success');
    const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      setOpen(false);
    };
const handleSelect = (ranges) => {
  const { startDate, endDate } = ranges.selection;
  const dayDiff = dayjs(endDate).diff(dayjs(startDate), 'day') + 1; // include start date

  // Allow only 1 to 7 days range
  if (dayDiff < 1 || dayDiff > 7) {
     setOpen(true)
               setAlertMessage('"Please select a week date range only"')
               setSeverity('warning')
              setTimeout(() => {
               setOpen(false)
              }, 2000);
    return;
  }

  setSelectedDateRange({
    startDate,
    endDate,
    key: 'selection',
  });
};


  // const handleSelect = (ranges) => {
  //   setSelectedDateRange(ranges.selection);
  // };

  const onClickDone = () => {
    onSubmit();
  };

  const onClickClear = () => {
    setSelectedDateRange({
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    });
    setShow(false);
  };

  return (
    <React.Fragment>
      <ToastMessage message={alertmessage} severity={severity} open={open} handleClose={handleClose} />
      {/* <div className="shadow bg-white d-inline-block text-md pb-2">
        <DateRangePicker
          onChange={handleSelect}
          showSelectionPreview={true}
          moveRangeOnFirstSelection={false}
          months={1}
          ranges={[selectedDateRange]}
          direction="horizontal"
    
        />
      </div> */}
<div className="shadow bg-white d-inline-block text-md pb-2">
  <DateRange
    onChange={handleSelect}
    moveRangeOnFirstSelection={false}
    months={1}
    ranges={[selectedDateRange]}
    direction="horizontal"
    showSelectionPreview={true}
  />
</div>

      {/* Add custom styles */}
      <style jsx>{`
        .rdrDateRangePickerWrapper {
          background-color: #f4f4f4; /* Light background color for the calendar */
          border-radius: 10px; /* Rounded corners for the calendar */
          font-family: 'Arial', sans-serif; /* Custom font for calendar */
          
        }
        
         .rdrDateDisplayWrapper {
          display: none; /* Hides the top date display (month/year) */
        }

        .rdrDateDisplayItem {
          font-size: 14px; /* Adjust font size for date display */
          padding: 10px;
        }

        .rdrDayNumber {
          color: #333; /* Dark color for day numbers */
        }

        .rdrSelectedDate {
          background-color: #28a745; /* Green background for selected date */
          color: white; /* White text for selected date */
        }

        .rdrMonthAndYear {
          font-weight: bold; /* Bold font for month and year */
        }

        /* Style for the buttons */
        .rdrCancelButton, .rdrApplyButton {
          background-color: #28a745; /* Green button color */
          color: white;
          border-radius: 5px;
          padding: 8px 16px;
          font-weight: bold;
        }

        .rdrCancelButton:hover, .rdrApplyButton:hover {
          background-color: #218838; /* Darker green on hover */
        }

        /* Custom styling for individual days */
        .rdrDay:hover {
          background-color: #d1ecf1; /* Light blue hover effect on days */
          cursor: pointer;
        }
      `}</style>
    </React.Fragment>
  );
};

DateRangeSelector.defaultProps = {
  ranges: defaultStaticRanges,
};

DateRangeSelector.propTypes = {
  /**
   * On Submit
   */
  onSubmit: PropTypes.func,
};

export default DateRangeSelector;
